<template>
  <div>
    <div class="footer_content">
      <!-- <div class="footer_content-title">产品在线购买</div>
      <div class="footer_content-shops">
        <el-row>
          <el-col class="footer_content-shops-item" :span="6">
            <div
              class="footer_content-shops-item-pic"
              v-bgImg="require('@@/assets/img/westa/店招/zxcp1.png')"
            ></div>
            <div>
              <div class="footer_content-shops-item-name">天猫官方旗舰店</div>
              <a href="http://t.cn/RpxiYFS?changdi.tmall.com/">
                <div class="footer_content-shops-item-btn">立即进入 ></div>
              </a>
            </div>
          </el-col>
          <el-col class="footer_content-shops-item" :span="6">
            <div
              class="footer_content-shops-item-pic"
              v-bgImg="require('@@/assets/img/westa/店招/zxcp2.png')"
            ></div>
            <div>
              <div class="footer_content-shops-item-name">京东官方旗舰店</div>
              <a href="http://t.cn/EbNkkMi?mall.jd.com/index-1000001342.html">
                <div class="footer_content-shops-item-btn">立即进入 ></div>
              </a>
            </div>
          </el-col>
          <el-col class="footer_content-shops-item" :span="6">
            <div
              class="footer_content-shops-item-pic"
              v-bgImg="require('@@/assets/img/westa/店招/zxcp4.png')"
            ></div>
            <div>
              <div class="footer_content-shops-item-name">苏宁官方旗舰店</div>
              <a href="https://shop.suning.com/30000433/index.html">
                <div class="footer_content-shops-item-btn">立即进入 ></div>
              </a>
            </div>
          </el-col>
          <el-col class="footer_content-shops-item" :span="6">
            <div
              class="footer_content-shops-item-pic"
              v-bgImg="require('@@/assets/img/westa/店招/zxcp3.png')"
            ></div>
            <div>
              <div class="footer_content-shops-item-name">其他官方旗舰店</div>
              <a href="http://www.westa.com.cn/shopping_45.html">
                <div class="footer_content-shops-item-btn">立即进入 ></div>
              </a>
            </div>
          </el-col>
        </el-row>
      </div>-->
      <div class="footer_content-tags">
        <div class="footer_content-tags-flex">
          <div class="footer_content-tags-flex-item">
            <p>{{ utils.local(lang, "关于长帝") }}</p>
            <a href="/about?id=0" class="footer_content-tags-p">{{ utils.local(lang, "品牌介绍") }}</a>
            <a href="/about?id=1" class="footer_content-tags-p">{{ utils.local(lang, "发展历程") }}</a>
            <a href="/about?id=2" class="footer_content-tags-p">{{ utils.local(lang, "企业文化") }}</a>
            <a href="/about?id=3" class="footer_content-tags-p">{{ utils.local(lang, "荣誉奖项") }}</a>
          </div>
          <div class="footer_content-tags-flex-item">
            <p>{{ utils.local(lang, "产品中心") }}</p>
            <a :href="'/product?id=' + item.category_id" class="footer_content-tags-p" v-for="(item, index) in website_product_categories" :key="index">{{ item.category_name }}</a>
          </div>
          <div class="footer_content-tags-flex-item">
            <p>{{ utils.local(lang, "品牌活动") }}</p>
            <a href="/activity" class="footer_content-tags-p">{{ utils.local(lang, "企业新闻") }}</a>
          </div>
          <div class="footer_content-tags-flex-item" v-show="chooseLang === 'CN'">
            <p>长帝烘焙</p>
            <!-- <p class="footer_content-tags-p">乐焙小程序</p> -->
            <a :href="'/baking?id=' + video_id" class="footer_content-tags-p">长帝美食视频</a>
          </div>
          <div class="footer_content-tags-flex-item" v-show="chooseLang === 'CN'">
            <p>在线服务</p>
            <a href="/service?tag=产品报修" class="footer_content-tags-p">产品报修</a>
            <a href="/service?tag=使用指南" class="footer_content-tags-p">使用指南</a>
          </div>
          <div class="footer_content-tags-flex-item" v-show="chooseLang === 'CN'">
            <p>加入长帝</p>
            <a href="/join?tag=招聘职位" class="footer_content-tags-p">招聘职位</a>
            <a href="/join?tag=公司福利" class="footer_content-tags-p">公司福利</a>
            <a href="/join?tag=公司架构" class="footer_content-tags-p">公司架构</a>
            <a href="/join?tag=员工风采" class="footer_content-tags-p">员工风采</a>
          </div>
        </div>
        <div>
          <div class="footer_content-tags-right">
            <a href="/contact">
              <div class="footer_content-tags-contact" v-bgImg="require('@@/assets/img/westa/home/联系我们.png')" v-show="chooseLang === 'CN'"></div>
              <div class="footer_content-tags-contact" v-bgImg="require('@@/assets/img/westa/home/联系我们-en.png')" v-show="chooseLang === 'EN'"></div>
            </a>
            <p class="footer_content-info-row-p2">400-830-3636</p>
            <p class="footer_content-info-row-p1">{{ utils.local(lang, "全国统一服务热线") }}</p>
            <div class="footer_content-info-pic">
              <!-- <div class="footer_content-tags-imgp">
                <img class="footer_content-tags-img" src="@@/assets/img/westa/home/WechatIMG336.png" width="92" height="92" />
                <p>{{utils.local(lang,"乐焙小程序")}}</p>
              </div> -->
              <div class="footer_content-tags-imgp">
                <img class="footer_content-tags-img" src="@@/assets/img/westa/home/xiaohongshu.png" width="92" height="92" />
                <p>{{ utils.local(lang, "官方小红书") }}</p>
              </div>
              <div class="footer_content-tags-imgp">
                <img class="footer_content-tags-img" src="@@/assets/img/westa/home/douyin.jpg" width="92" height="92" />
                <p>{{ utils.local(lang, "官方抖音") }}</p>
              </div>
              <div class="footer_content-tags-imgp">
                <img class="footer_content-tags-img" src="@@/assets/img/westa/home/weixin.png" width="92" height="92" />
                <p>{{ utils.local(lang, "官方微信") }}</p>
              </div>
              <div class="footer_content-tags-imgp">
                <img class="footer_content-tags-img" src="@@/assets/img/westa/home/weibo.png" width="92" height="92" />
                <p>{{ utils.local(lang, "官方微博") }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- <el-col :span="3" class="footer_content-tags-title">
          <p>官方微信</p>
          <img class="footer_content-tags-img" src="@@/assets/img/westa/店招/weixin.jpg">
        </el-col>
        <el-col :span="3" class="footer_content-tags-title">
          <p>新浪微博</p>
          <img class="footer_content-tags-img" src="@@/assets/img/westa/店招/weibo.jpg">
        </el-col>-->
      </div>
      <!-- <div class="footer_content-info">
        <el-row class="footer_content-info-row">
          <el-col :span="10">
            <p>总部地址：广东省佛山市顺德区杏坛镇科技七路3号 电话：0757-28381788</p>
            <br>
            <p>国内营销中心：广东省佛山市顺德区杏坛镇科技七路3号 电话：0757-28381794</p>
            <br>
            <p>©1993-2019 广东伟仕达电器科技有限公司 粤ICP备12009362号-5</p>
          </el-col>
          <el-col :span="4" :offset="10">
            <br>
            <p class="footer_content-info-row-p1">全国统一服务热线</p>
            <br>
            <p class="footer_content-info-row-p2">400-830-3636</p>
          </el-col>
        </el-row>
      </div>-->
      <div style="width:100%;text-align:center;padding:40px;box-sizing:border-box">
        <p style="font-size:0.65rem;color:#999999">广东伟仕达电器科技有限公司</p>
        <a style="color:#181f99;font-size:0.65rem" target="_blank" href="https://beian.miit.gov.cn">粤ICP备12009362号</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        lang: "base-footer",
        website_product_categories: [],
        website_video_categories: [],
        video_id: "",
        chooseLang: "CN",
      };
    },
    created() {
      this.chooseLang = this.utils.getCookie("lang");
      this.getCategories();
      // this.getWebsiteVideoCategories();
    },
    methods: {
      toPath(path) {
        this.$router.push(path);
      },
      getCategories() {
        if (this.chooseLang === "CN") {
          let product_categories = JSON.parse(localStorage.getItem("product_categories"));
          if (product_categories === null) {
            let params = {};
            this.req
              .get(url_api_web_websiteProductCategory_getWebsiteProductCategories, this.qs.stringify(params))
              .then((result) => {
                this.website_product_categories = result.website_product_categories;
                localStorage.setItem("product_categories", JSON.stringify(this.website_product_categories));
              })
              .catch((error) => {});
          } else {
            this.website_product_categories = product_categories;
          }
        } else if (this.chooseLang === "EN") {
          let product_categories = JSON.parse(localStorage.getItem("product_categories-en"));
          if (product_categories === null) {
            let params = {};
            this.req
              .get(url_api_web_websiteProductCategory_getWebsiteProductCategories, this.qs.stringify(params))
              .then((result) => {
                this.website_product_categories = result.website_product_categories;
                localStorage.setItem("product_categories-en", JSON.stringify(this.website_product_categories));
              })
              .catch((error) => {});
          } else {
            this.website_product_categories = product_categories;
          }
        }
      },
      getWebsiteVideoCategories() {
        // if (this.chooseLang === "CN") {
        let video_categories = JSON.parse(localStorage.getItem("video_categories"));
        if (video_categories === null) {
          let params = {};
          this.req
            .get(url_api_web_websiteVideoCategory_getWebsiteVideoCategories, this.qs.stringify(params))
            .then((result) => {
              this.website_video_categories = result.website_video_categories;
              this.video_id = result.website_video_categories[0].category_id;
              localStorage.setItem("video_categories", JSON.stringify(this.website_video_categories));
            })
            .catch((error) => {});
        } else {
          this.website_video_categories = video_categories;
          this.video_id = this.website_video_categories[0].category_id;
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .footer_content {
    width: 100%;
    margin: 0 auto;
    min-width: 1200px;
    &-title {
      font-size: 30px;
      text-align: center;
      padding: 20px 0;
    }
    &-shops {
      width: 1200px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 20px;
      margin: 0 auto;
      &-item {
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #ddd;
        &:last-child {
          border-right: 0;
        }
        &-pic {
          width: 60px;
          height: 60px;
          margin-right: 12px;
        }
        &-name {
          font-size: 18px;
          color: #333;
        }
        &-btn {
          color: #999;
          margin-top: 12px;
          &:hover {
            color: #ff9600;
          }
        }
      }
    }
    &-tags {
      width: 1200px;
      // padding: 30px 0;
      margin: 0 auto;
      margin-top: 104px;
      color: #333;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      &-flex {
        display: flex;
        &-item {
          margin-right: 60px;
          display: flex;
          flex-direction: column;

          &:last-child {
            margin-right: 0;
          }
        }
      }
      &-p {
        font-size: 14px;
        color: #999;
        margin-top: 18px;
        cursor: pointer;
        &:hover {
          color: #181f99;
        }
      }
      &-title {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      &-imgp {
        margin-left: 24px;
        margin-top: 16px;
        color: #666;
        text-align: center;
        margin-bottom: 70px;
      }
      &-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
      &-contact {
        width: 178px;
        height: 54px;
      }
    }
    &-info {
      // height: 80px;
      padding: 20px 0;
      background: #f9f9f9;
      &-row {
        width: 1200px;
        margin: 0 auto;
        font-size: 12px;
        color: #999;
        &-p1 {
          font-size: 14px;
          // letter-spacing: 4px;
          color: #999;
        }
        &-p2 {
          font-size: 22px;
          color: #333;
          margin-top: 24px;
          margin-bottom: 16px;
        }
      }
      &-pic {
        display: flex;
        margin-top: 70px;
      }
    }
  }
</style>
